import React, { Component } from 'react';

class Hero extends Component {

  render() {
    return (
      <div className={"hero-overlay " + this.props.className}>
      	<div className="hero-overlay">
      		<div className="hero-container">
		  	    <div className="hero">
		  	    	{this.props.children}
				</div>
			</div>
		</div>
      </div>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/content/Hero.js